import React from 'react'

import ReportSegment from '../../generic/report-segment'
import Report from '../../../utility/report-service'
import { faExclamation } from '@fortawesome/free-solid-svg-icons'

function OnpageIssues() {
  return (
    <section className="onpage-issues">
      <div className="container">
        <h2 id="onpage-issues">Onpage Optimizing Issues</h2>
        <div className="row halves">
          <ReportSegment
            title="Error pages"
            subtitle="Bottom text"
            data={Report.onpageIssues.errorPages}
            icon={faExclamation}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Error files"
            subtitle="Bottom text"
            data={Report.onpageIssues.errorFiles}
            icon={faExclamation}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment title="Title" subtitle="Bottom text" data={Report.onpageIssues.titles}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment title="H1" subtitle="Bottom text" data={Report.onpageIssues.h1}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Alt Tag"
            subtitle="Bottom text"
            data={Report.onpageIssues.descriptions}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="File size"
            subtitle="Bottom text"
            data={Report.onpageIssues.fileSize}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment
            title="Response time"
            subtitle="Bottom text"
            data={Report.onpageIssues.responseTime}
          >
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
          <ReportSegment title="Index" subtitle="Bottom text" data={Report.onpageIssues.index}>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
            invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
          </ReportSegment>
        </div>
      </div>
    </section>
  )
}

export default OnpageIssues
